import React, { useRef, useState } from "react";
import GoogleMapReact from "google-map-react";
import useSupercluster from "use-supercluster";
import { Popover, OverlayTrigger, Overlay } from "react-bootstrap";
import TimeStamp from "react-timestamp";
import mapStyle from "./MapStyle";

export default function MyMap(props) {
  // setup Map
  const Marker = ({ children }) => children;
  const [zoom, setZoom] = useState(10);
  const [bounds, setBounds] = useState(null);
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const mapRef = useRef();
  // const mapOptions = {
  //     styles: mapStyle
  // };

  // console.log(props.incomingLogs)
  // typeof props.incomingLogs;
  // console.log(typeof props.incomingLogs)

  // const crimes = data && !error ? data.slice(0, 2000) : [];
  const logs = props.incomingLogs ? props.incomingLogs : [];
  // console.log("Hello Here");
  // console.log(logs);

  const points = logs.map((incomingLog) => ({
    type: "Feature",
    properties: {
      cluster: false,
      incomingId: incomingLog.key,
      lockedStatus: incomingLog.lockedStatus,
      address: incomingLog.Placemark,
      timeStamp: incomingLog.time,
      email: incomingLog.userEmail,
    },
    geometry: {
      type: "Point",
      coordinates: [
        parseFloat(incomingLog.Longitude),
        parseFloat(incomingLog.Latitude),
      ],
    },
  }));
  // console.log(logPoints)
  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    options: { radius: 75, maxZoom: 22 },
  });
  // console.log(clusters)
  return (
    <div style={{ height: "75vh", width: "75%" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_API_KEY }}
        defaultCenter={{ lat: 1.275821903978486, lng: 103.79596010423822 }}
        defaultZoom={1}
        // options={mapOptions}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map }) => {
          mapRef.current = map;
        }}
        onChange={({ zoom, bounds }) => {
          setZoom(zoom);
          setBounds([
            bounds.nw.lng,
            bounds.se.lat,
            bounds.se.lng,
            bounds.nw.lat,
          ]);
        }}
      >
        {clusters.map((cluster) => {
          const [longitude, latitude] = cluster.geometry.coordinates;
          const {
            cluster: isCluster,
            point_count: pointCount,
          } = cluster.properties;

          if (isCluster && zoom < 22) {
            return (
              <Marker
                key={`cluster-${cluster.id}`}
                lat={latitude}
                lng={longitude}
              >
                <div
                  className="clusterPin"
                  style={{
                    width: `${10 + (pointCount / points.length) * 40}px`,
                    height: `${10 + (pointCount / points.length) * 40}px`,
                  }}
                  onClick={() => {
                    const expansionZoom = Math.min(
                      supercluster.getClusterExpansionZoom(cluster.id),
                      20
                    );
                    mapRef.current.setZoom(expansionZoom);
                    mapRef.current.panTo({ lat: latitude, lng: longitude });
                  }}
                >
                  {pointCount}
                </div>
              </Marker>
            );
          } else if (isCluster && zoom === 22) {
            // console.log("YES");
            return (
              <Marker
                key={`cluster-${cluster.id}`}
                lat={latitude}
                lng={longitude}
              >
                <div
                  className="clusterPin"
                  style={{
                    width: `${10 + (pointCount / points.length) * 40}px`,
                    height: `${10 + (pointCount / points.length) * 40}px`,
                  }}
                  onClick={() => {
                    setShow(!show);
                  }}
                >
                  <Overlay
                    target={target.current}
                    show={show}
                    placement="right"
                  >
                    {({
                      placement,
                      scheduleUpdate,
                      arrowProps,
                      outOfBoundaries,
                      show: _show,
                      ...props
                    }) => (
                      <div
                        {...props}
                        style={{
                          backgroundColor: "rgba(255, 100, 100, 0.85)",
                          padding: "2px 10px",
                          color: "white",
                          borderRadius: 3,
                          ...props.style,
                        }}
                      >
                        Simple tooltip
                      </div>
                    )}
                  </Overlay>
                  {pointCount}
                </div>
              </Marker>
            );
          }

          const popover = (
            <Popover id="popover-basic" title={cluster.properties.key}>
              <label>Address:</label>
              <p>{cluster.properties.address}</p>
              <label>Date and Time: </label>
              <br />
              <TimeStamp
                time={cluster.properties.timeStamp / 1000}
                format="full"
                includeDay
              />
              <label>Opened By: </label>
              <p>{cluster.properties.email}</p>
              <p>{cluster.properties.lockedStatus}</p>
            </Popover>
          );

          return (
            <Marker
              key={`lock-${cluster.properties.incomingId}`}
              lat={latitude}
              lng={longitude}
            >
              <OverlayTrigger placement="right" overlay={popover}>
                <div className="testPin"></div>
              </OverlayTrigger>
            </Marker>
          );
        })}
      </GoogleMapReact>
    </div>
  );
}
